import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import withStore from "@/hocs/withStore";
import {Head, usePage} from "@inertiajs/inertia-react";
import {Inertia} from "@inertiajs/inertia";
import isEmpty from "is-empty";
import {getProperty, isDesktop, isMobile} from "@/Helpers/Function";
import classNames from "classnames";
import LinkLoad from "@/Layouts/LinkLoad";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import ModalWindowsComponent from "@/Pages/All/ModalWindowsComponent";
import Country from "@/Pages/Header/Country";
import SelectCity from "@/Pages/Header/SelectCity";
import Logo from "@/Pages/Header/Logo";
import Svg from "@/Pages/All/Svg";
import SearchForm from "@/Pages/Header/SearchForm";
import MobileMenu from "@/Pages/Header/MobileMenu";
import CatalogMobileSubMenu from "@/Pages/Header/CatalogMobileSubMenu";
import FooterNavMobile from "@/Pages/Footer/FooterNavMobile";
import PWA from "@/Pages/Footer/PWA";
// import moment from 'moment-timezone';
import '@/Pages/Header/scss/index.scss';
import '@/Pages/Footer/scss/index.scss';
import useScrollDirection from "@/Hooks/useScrollDirection";

// const momentDate = moment.tz.setDefault("Europe/Moscow");

function BaseLayout({title, children, ...props}) {
    const {
        stores = {},
        basketProducts = [],
        favouritesData = [],
        mobileApp = false,
        description = "",
        pathCanonical = "",
        robots = "",
        errors = {},
        config = {},
        // mainSale = {},
        user
    } = props;
    const {
        allStore,
        favouritesStore = {},
        basketStore = {},
        filterStore = {},
        modalStore = {},
        subMenuStore = {}
    } = stores;
    const {url} = usePage();
    const {saleTypes = {}} = config;
    const {wheelOfFortune = {}} = saleTypes;

    addEventListener('popstate', (event) => {
        allStore.prevButton = true;
    });

    // Отправка user id в dataLayer (Задача № 5895)
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        const item = window.dataLayer.find(item => item.event === 'userId') ?? {};
        const {event = null} = item;
        if (user.id !== null && event === null) {
            window.dataLayer.push({
                'event': 'userId',
                'user_id': `${user.id}`
            });
        }
    }, [user.id]);

    // Если 500
    useEffect(() => {
        if (errors?.fatalErrorMessage) {
            basketStore.errorOrderMessage = errors.fatalErrorMessage;
            basketStore.openDialogBasket();
        }
    }, [errors]);

    // Чтобы важные изменения страницы фиксировались Яндекс Метрикой
    useEffect(() => {
        let attempts = 0;
        // Максимальное количество попыток
        const maxAttempts = 150;
        const intervalId = setInterval(() => {
            attempts++;
            if (typeof ym === "function" || attempts >= maxAttempts) {
                // Остановить вызов каждую секунду
                clearInterval(intervalId);
                if (typeof ym === "function") {
                    // Вызвать функцию ym
                    ym(45198306, 'hit', location.href);
                } else {
                    // Если ym так и не стало доступной
                    console.log("ym is not available");
                }
            }
        }, 100);
    }, [url]);

    useEffect(() => {
        setTimeout(() => {
            if (isEmpty(localStorage.getItem('cityCookieDadataAdd'))) {
                localStorage.setItem('cityCookieDadataAdd', true);
                axios.post('/cityCookieDadataAdd', {}).then((response) => {
                    const {status = false} = response.data;
                    if (status) {
                        Inertia.reload()
                    }
                });
            }
        }, 5000)
    });

    useEffect(() => {
        basketStore.basketProductsUpdate(basketProducts);
    }, [basketProducts]);

    useEffect(() => {
        favouritesStore.favouritesDataChange(favouritesData);
    }, [favouritesData]);

    useEffect(() => {
        if (allStore.prevButton) {
            if (url.includes('catalog') && !url.includes('product')) {
                filterStore.catalogSend();
            } else if (url.includes('basket')) {
                basketStore.getBasket();
            } else if (url.includes('go-to-checkout')) {
                basketStore.getBasketGoToCheckout();
            } else {
                // if (url.includes('basket') || url.includes('go-to-checkout')) {
                //     basketStore.flagBonusesPromoCod = 'bonuses'; // По кнопкам назад/вперед всегда скидываем на бонусы
                // }
                // По кнопкам назад вперед всегда запрашиваем данные с сервера
                Inertia.reload();
            }
        }

        allStore.prevButton = false;
        allStore.prevPathname = url;
    }, []);

    /**
     * Показываем окно с колесом фортуны
     */
    useEffect(() => {
        /**
         * Проходим далее если:
         * 1. На сайт попадают не из приложений
         * 2. Дата не null
         * 3. Текущая дата меньше установленной
         * 4. Окно показывается в первые
         */
        if (mobileApp || wheelOfFortune.endDate === null || new Date() > new Date(wheelOfFortune.endDate) || !isEmpty(localStorage.getItem('wheelOfFortune'))) {
            return;
        }

        // Показываем окно с задержкой в 3 секунды
        setTimeout(() => {
            modalStore.openWheelOfFortuneModal();
        }, 3000)
    }, []);

    // Закрытие модальных окон
    useEffect(() => {
        modalStore.closeDiamondHeadsetStarsModal();
        modalStore.closeModalSelectSize();
        modalStore.closeModalAdditionalChoiceSoul();
        modalStore.closeModalPriceInfo();
        modalStore.closeModalScanner();
        modalStore.closeFindOutPriceModal();
        stores.subMenuStore.closeSubMenu();
        stores.addSnackbarsStore.openAddSnackbars = false;
        stores.buyOneClickStore.closeModal();
        stores.mobileMenuStore.closeMobileMenu();
        stores.rightMenuStore.closeRightMenu();
        stores.searchStore.closeSearchModal();
        stores.subMenuStore.open = false;
        stores.subMenuStore.closeMobileSubMenu();
        stores.quickViewStore.closeModal();
        stores.profileStore.closeQuestionModal();
        stores.productDetailStore.closeModalEntrance();
    }, []);

    // Re rendering
    useEffect(() => {
        //
    }, [subMenuStore.open, subMenuStore.newImg, basketStore.basketCount, favouritesStore.favouritesData]);

    // Модальное окно "Продолжить в приложении"
    useEffect(() => {
        const application = sessionStorage.getItem('continueApplication');
        if (!mobileApp && isMobile() && application === null) {
            modalStore.openApplicationDrawer();
        }
    }, []);

    const navDesktop = (props) => {
        const {stores = {}, soulSubMenu = []} = props;
        const {subMenuStore = {}} = stores;
        const subMenuClass = `nav__item ${subMenuStore.subMenuFlag ? 'open' : ''}`;

        const open = classNames('sub-menu', props.className, {
            'open': subMenuStore.subMenuFlag
        });

        const openOverlay = classNames('soul-sub-menu-overlay', props.className, {
            'open': subMenuStore.subMenuFlag
        });

        // if (soulSubMenu.length === 0) {
        //     return null;
        // }

        return (
            <nav className={`nav`}>
                <div className={`container`}>
                    <LinkLoad className={`nav__item`} href={`/stocks`}>Акции</LinkLoad>
                    {/*<LinkLoad className={`nav__item`} href={`/wheel-of-fortune`}>Розыгрыш</LinkLoad>*/}
                    <LinkLoad className={`nav__item`} href={`/buket-podarkov`}>Розыгрыш</LinkLoad>
                    {/*<LinkLoad className={`nav__item`} href={`/advent-calendar`}>Адвент-календарь</LinkLoad>*/}
                    {/*<p className={subMenuClass} onClick={() => subMenuStore.subMenuOpen()}>*/}
                    {/*    Соул-браслеты*/}
                    {/*</p>*/}
                    <LinkLoad className={`nav__item`} href={`/wedding`}>Свадьба</LinkLoad>
                    <LinkLoad className={`nav__item`} href={`/collections`}>Коллекции</LinkLoad>
                    <LinkLoad className={`nav__item`} href={`/gift-certificate`}>Подарочные сертификаты</LinkLoad>
                    <LinkLoad className={`nav__item`} href={`/b2b`}>Бизнесу</LinkLoad>
                    <LinkLoad className={`nav__item`} href={`/about-company`}>О компании</LinkLoad>
                    <LinkLoad className={`nav__item`} href={`/blog`}>Блог</LinkLoad>
                    <LinkLoad className={`nav__item`} href={`/contacts`}>Контакты</LinkLoad>
                </div>
                {subMenuStore.subMenuFlag && (
                    <>
                        <div className={open}>
                            <div className={`container`}>
                                <div className={`sub-menu__wrapper`}>
                                    {soulSubMenu.map((el) => {
                                        return <LinkLoad key={el.id}
                                                         className={`sub-menu__item`}
                                                         href={`${el.link}`}>
                                            {el.name}
                                        </LinkLoad>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className={openOverlay} onClick={() => subMenuStore.closeSubMenu()}></div>
                    </>
                )}
            </nav>
        );
    };

    const headerMobile = (props) => {
        const {stores = {}, authCheck = false, user = {}} = props;
        const {rightMenuStore = {}, basketStore = {}, favouritesStore = {}, mobileMenuStore = {}} = stores;

        const headerRef = useRef(null);

        useEffect(() => {
            const updateHeight = () => {
                if (headerRef.current) {
                    allStore.setHeight(headerRef.current.offsetHeight);
                }
            };

            const observer = new ResizeObserver(updateHeight);
            if (headerRef.current) {
                observer.observe(headerRef.current);
            }

            return () => observer.disconnect();
        }, []);

        const active_orders = getProperty(user, 'ordersCount', 0) + getProperty(user, 'returnOrdersCount', 0);

        const scrollDirection = useScrollDirection();

        // const [headerApp, setHeaderApp] = useState(sessionStorage.getItem('headerApp'));
        //
        // const headerBoxInstallAppsClose = () => {
        //     sessionStorage.setItem('headerApp', '1');
        //     setHeaderApp(sessionStorage.getItem('headerApp'));
        // };
        //
        // const headerBoxInstallApps = () => {
        //     if (headerApp !== null) {
        //         return null;
        //     }
        //
        //     return <>
        //         <div className={`container`}>
        //             <div className={`headerBoxInstallApps`}>
        //                 <Svg id={`dagger-close`}
        //                      onClick={() => headerBoxInstallAppsClose()}
        //                      className={`MuiSvgIcon-root svg__dagger-close mr8`} />
        //                 <Svg id={`installIcon`} className={`svg__installIconAppHeader`} />
        //                 <div className={`headerBoxInstallApps__text`}>
        //                     <p className={`first`}>Откройте в приложении</p>
        //                     <p className={``}>{installAppsText}</p>
        //                 </div>
        //                 <a href={`https://platina.onelink.me/XKls/3h9xijzw`}
        //                    className={`headerBoxInstallApps__openApp`}
        //                    role={`button`}
        //                 >
        //                     Открыть
        //                 </a>
        //             </div>
        //         </div>
        //         <div className={`headerBoxInstallAppsLine`}></div>
        //     </>
        // };

        return (
            <header ref={headerRef} className={`header${scrollDirection === "down" ? " hide" : " show"}`}
                    style={{transform: scrollDirection === "down" ? `translateY(-${allStore.headerHeight}px)` : "translateY(0)"}}>
                {/*{headerBoxInstallApps()}*/}
                <MainSale {...props} />
                <div className={`container`}>
                    <div className={`headerBox`}>
                        <div className={`headerBox__item headerBox__item_left`}>
                            <p className={`p-10`} onClick={() => mobileMenuStore.openMobileMenu()}>
                                <Svg id={`mobile-menu`} className={`svg__mobile-menu`} />
                            </p>
                        </div>
                        <div className={`headerBox__item headerBox__item_center`}>
                            <Logo />
                        </div>
                        <div className={`headerBox__item headerBox__item_right`}>
                            <div className={`headerBox__icons`}>
                                {!isDesktop() && (
                                    <LinkLoad href={`/search`} aria-label="Главная" className={`icon`}>
                                        <Svg id={`search`} className={`svg__searchHeader`} />
                                    </LinkLoad>
                                )}
                                {!isMobile() && (
                                    <>
                                        <div className={`icon icon__profile`}
                                             onClick={() => rightMenuStore.openRightMenu()}
                                        >
                                            <Svg id={`profile`} className={`svg__profile`} aria-label="Профиль" />
                                            {authCheck && active_orders !== 0 && (
                                                <span className={`icon__dots`}></span>
                                            )}
                                        </div>

                                        <LinkLoad
                                            className={`icon icon__favorites`}
                                            href={`/favorites`}
                                        >
                                            <Svg
                                                id={`heart-header`}
                                                className={`svg__heart`}
                                                aria-label="Избранное"
                                            />
                                            {favouritesStore.favouritesData.length !== 0 &&
                                                <span className={`icon__dots`}></span>}
                                        </LinkLoad>

                                        <LinkLoad className={`icon inertiaButton`}
                                                  href={`/basket`}
                                                  method={`post`}
                                                  as={'button'}
                                                  data={{
                                                      paymentMethod: basketStore.valuePaymentMethod,
                                                      // flagBonusesPromoCod: basketStore.flagBonusesPromoCod,
                                                      // promoCodeValue: basketStore.promo_id,
                                                      promoCodeValue: basketStore.promoCodeValues,
                                                      certificateData: basketStore.certificateData,
                                                      // deliveryData: basketStore.deliveryData,
                                                      bonuses: basketStore.subtractBonuses,
                                                  }}
                                        >
                                            <Svg id={`headerBasket`} className={`svg__basket`} />
                                            {basketStore.basketCount !== 0 &&
                                                <span className={`basket-count`}>{basketStore.basketCount}</span>}
                                        </LinkLoad>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <MobileMenu {...props} />
                <CatalogMobileSubMenu {...props} />
            </header>
        );
    };

    function IconGooglePlay(props) {
        return (
            <svg
                width={120}
                height={38}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M38.944 9.984l-.725-.573c.551-.821 1.36-1.232 2.427-1.232.763 0 1.36.2 1.791.597.442.399.662.919.662 1.563 0 .415-.11.78-.33 1.092a2.05 2.05 0 01-.839.7c.55.125.97.389 1.258.788.296.397.444.862.444 1.396 0 .881-.352 1.571-1.054 2.071-.543.373-1.187.559-1.932.559-.77 0-1.41-.194-1.919-.584a3.664 3.664 0 01-1.142-1.449l.914-.406c.17.475.45.85.838 1.13.393.281.865.428 1.348.42.516 0 .949-.119 1.295-.356.458-.321.688-.775.688-1.359 0-1.11-.755-1.665-2.263-1.665h-.763v-.889h.763c.559 0 .987-.136 1.284-.406.296-.271.444-.615.444-1.03 0-.362-.114-.66-.343-.888-.254-.263-.635-.394-1.144-.394-.711 0-1.279.305-1.702.915zm10.23 2.287v-.75h.915v5.271h-.915v-.737a2.17 2.17 0 01-1.805.89 2.491 2.491 0 01-1.816-.738c-.5-.49-.75-1.176-.75-2.057 0-.863.246-1.537.737-2.02.5-.491 1.109-.738 1.829-.738.762 0 1.364.294 1.805.878v.001zm-1.703-.065c-.482 0-.893.175-1.232.521-.33.34-.496.813-.496 1.423 0 .585.153 1.063.457 1.436.314.364.737.546 1.271.546.534 0 .957-.19 1.27-.572.323-.38.483-.846.483-1.396 0-.628-.178-1.11-.533-1.45a1.72 1.72 0 00-1.22-.508zm4.35 4.588v-5.275h3.125v.838h-2.211v4.434h-.915l.001.003zm4.959-.738v3.659h-.915V11.52h.915v.738c.466-.575 1.067-.864 1.804-.864.787 0 1.41.278 1.867.837.466.552.7 1.204.7 1.958 0 .762-.23 1.413-.687 1.956-.458.534-1.072.8-1.841.8-.772 0-1.386-.296-1.843-.889zm1.715.075c.516 0 .931-.185 1.245-.557.313-.381.47-.844.47-1.385 0-.61-.174-1.093-.521-1.449-.346-.355-.75-.534-1.206-.534-.458 0-.864.179-1.22.534-.357.356-.534.835-.534 1.436 0 .55.161 1.017.482 1.398.331.372.759.559 1.284.559v-.002zm4.045 3.584l1.676-3.418-2.425-4.777h1.042l1.867 3.775 1.715-3.775h1.016l-3.875 8.195H62.54zm6.294-6.848l-.635-.52c.204-.297.427-.517.674-.66.33-.196.715-.293 1.156-.293.532 0 .947.122 1.243.368.305.263.458.597.458 1.004 0 .492-.199.859-.596 1.105.234.048.447.168.61.343.245.262.367.585.367.966 0 .568-.229 1.02-.685 1.359-.374.271-.872.406-1.5.406-.558 0-1.029-.148-1.41-.444-.287-.212-.521-.512-.699-.902l.788-.33a1.4 1.4 0 001.334.864c.399 0 .695-.068.89-.204.245-.162.369-.406.369-.738a.674.674 0 00-.32-.609c-.177-.118-.464-.177-.862-.177h-.535v-.839h.445c.323 0 .55-.046.686-.14a.549.549 0 00.28-.482c0-.238-.076-.42-.228-.546-.144-.128-.369-.192-.674-.192-.262 0-.504.068-.725.204-.18.113-.33.27-.431.457zm4.673-1.347h.915v3.481l3.608-3.887v5.678h-.914v-3.517l-3.609 3.888V11.52zm9.71.839h-1.652v4.434h-.915v-4.434h-1.651v-.838h4.217v.838zm4.75 2.668l.762.42c-.164.32-.384.608-.649.85-.483.432-1.066.648-1.752.648a2.688 2.688 0 01-1.843-.685c-.507-.466-.763-1.156-.763-2.071 0-.805.23-1.47.688-1.995.465-.534 1.088-.8 1.866-.8.882 0 1.547.321 1.995.965.355.508.522 1.168.495 1.982h-4.102c.007.534.172.965.495 1.295.321.332.715.497 1.181.497.415 0 .775-.128 1.08-.382.233-.198.42-.446.546-.725v.002zm-3.24-1.448h3.1a1.647 1.647 0 00-.547-.992 1.44 1.44 0 00-1.004-.38c-.381 0-.72.13-1.016.393a1.63 1.63 0 00-.534.979zm8.408-2.059h1.995c.483 0 .85.103 1.105.305.305.246.457.576.457.991a1.18 1.18 0 01-.572 1.055c.262.068.484.186.661.355.28.271.419.61.419 1.016 0 .51-.181.907-.546 1.195-.313.238-.728.355-1.245.355h-2.274V11.52zm.915 2.148h.965c.246 0 .441-.05.585-.153a.64.64 0 00.254-.546.604.604 0 00-.254-.508c-.127-.085-.372-.127-.737-.127h-.813v1.334zm0 2.312h1.13c.39 0 .665-.06.826-.178a.7.7 0 00.305-.585.725.725 0 00-.267-.597c-.16-.126-.435-.19-.825-.19H94.05v1.55zM42.209 26.9v-1.425h3.887v.102c0 1.517-.415 2.685-1.245 3.507-.745.745-1.748 1.119-3.01 1.119-1.287 0-2.312-.382-3.075-1.144-.837-.838-1.257-1.927-1.257-3.265 0-1.271.415-2.322 1.245-3.15.846-.865 1.96-1.296 3.341-1.296.745 0 1.398.147 1.956.443.653.331 1.181.848 1.588 1.55l-1.435.775a2.315 2.315 0 00-.992-1.003 2.633 2.633 0 00-1.193-.267c-.797 0-1.449.25-1.956.75-.568.55-.852 1.295-.852 2.235 0 .89.279 1.605.838 2.148.5.482 1.127.725 1.881.725.66 0 1.215-.17 1.664-.509.406-.313.673-.745.8-1.296h-2.185v.001zm5.827-1.792c.559-.517 1.3-.776 2.224-.776.922 0 1.664.26 2.223.776.618.558.927 1.278.927 2.16 0 .872-.309 1.587-.927 2.147-.56.516-1.3.775-2.223.775-.924 0-1.665-.259-2.224-.775-.619-.56-.927-1.275-.927-2.148 0-.88.308-1.6.927-2.16zm1.119 3.252c.296.305.664.457 1.105.457.44 0 .809-.152 1.105-.457a1.511 1.511 0 00.445-1.093c0-.432-.149-.8-.445-1.104a1.478 1.478 0 00-1.105-.458c-.441 0-.809.153-1.105.458a1.527 1.527 0 00-.445 1.104c0 .424.149.788.445 1.093zm6.102-3.252c.56-.517 1.3-.776 2.223-.776.924 0 1.665.26 2.224.776.618.558.927 1.278.927 2.16 0 .872-.31 1.587-.927 2.147-.559.516-1.3.775-2.224.775-.922 0-1.664-.259-2.222-.775-.62-.56-.928-1.275-.928-2.148 0-.88.309-1.6.928-2.16zm1.118 3.252c.296.305.665.457 1.105.457.441 0 .809-.152 1.105-.457a1.511 1.511 0 00.445-1.093c0-.432-.148-.8-.444-1.104a1.48 1.48 0 00-1.106-.458c-.44 0-.809.153-1.105.458a1.529 1.529 0 00-.445 1.104c0 .424.149.788.445 1.093zm9.647-3.137v-.713h1.55v5.247c0 .517-.05.965-.152 1.347-.1.402-.311.768-.61 1.055-.516.516-1.241.775-2.172.775-.898 0-1.584-.213-2.06-.635-.448-.381-.744-.928-.887-1.639h1.675c.054.255.188.486.383.66.211.195.525.293.94.293.381 0 .694-.116.94-.344.262-.254.393-.66.393-1.219v-.775c-.398.61-.962.914-1.69.914-.762 0-1.397-.25-1.904-.75-.585-.584-.878-1.313-.878-2.184 0-.906.284-1.635.851-2.185.509-.491 1.14-.738 1.894-.738.763 0 1.337.298 1.727.89zm-1.347.482c-.415 0-.758.126-1.029.381-.33.297-.495.687-.495 1.169 0 .431.135.791.406 1.08.297.321.67.482 1.12.482.405 0 .75-.127 1.028-.38.33-.306.495-.7.495-1.182a1.547 1.547 0 00-.938-1.442 1.445 1.445 0 00-.587-.108zm4.375-4.955h1.55v9.262h-1.55V20.75zm7.004 7.495l1.424.229c-.064.16-.145.314-.242.457a4.41 4.41 0 01-.445.546c-.203.213-.478.387-.825.522a3.467 3.467 0 01-1.195.19c-.864 0-1.567-.258-2.109-.775-.576-.542-.863-1.258-.863-2.147 0-.88.278-1.6.837-2.16.525-.516 1.217-.774 2.072-.774.93 0 1.647.3 2.147.902.44.525.66 1.245.66 2.16v.126H73.4c0 .373.089.683.267.928.254.347.623.521 1.105.521.575 0 1.004-.241 1.283-.725h-.001zM73.45 26.53h2.604c-.059-.355-.215-.626-.47-.813a1.348 1.348 0 00-1.678 0c-.25.204-.413.494-.456.813zm8.459-4.992h2.466c.525 0 .953.046 1.284.14.337.084.656.253.952.507.575.509.864 1.19.864 2.046 0 .796-.232 1.426-.699 1.893-.5.5-1.215.75-2.147.75h-1.067v3.137H81.91l-.001-8.473zm1.652 1.422v2.49h.673c.484 0 .844-.087 1.08-.266.305-.238.457-.568.457-.992 0-.415-.156-.737-.47-.965-.254-.177-.644-.267-1.169-.267h-.57zm4.906-2.21h1.55v9.262h-1.55V20.75zm7.246 4.471v-.711h1.55v5.501h-1.55V29.3c-.415.592-.98.889-1.69.889-.83 0-1.508-.284-2.033-.85-.516-.568-.775-1.263-.775-2.084 0-.83.254-1.525.763-2.084.507-.558 1.163-.837 1.968-.837.797 0 1.385.295 1.767.887zm-.28.928a1.458 1.458 0 00-1.093-.444c-.44 0-.805.148-1.093.444a1.525 1.525 0 00-.432 1.106c0 .44.145.813.433 1.117.287.297.652.445 1.092.445.44 0 .805-.148 1.093-.445a1.57 1.57 0 00.432-1.117c0-.441-.144-.81-.432-1.106zm3.192 6.772l2.02-3.735-2.616-4.675h1.803l1.703 3.125 1.525-3.125h1.753l-4.434 8.41h-1.754z"
                    fill="#000"
                />
                <path
                    d="M11.071 10.114c0-.196.029-.368.075-.513L21.554 19.94 11.195 30.312a1.558 1.558 0 01-.125-.637V10.112l.001.002z"
                    fill="#000"
                    stroke="#000"
                    strokeWidth={0.726}
                />
                <path
                    d="M25.731 23.744l-3.623-3.629v-.265l3.625-3.63.087.088 4.331 2.48c1.238.707 1.238 1.858 0 2.566l-4.42 2.39z"
                    fill="#000"
                />
                <path
                    d="M25.819 23.656l-3.713-3.717L11.06 31c.441.444 1.06.444 1.856.09l12.904-7.435zm0-7.435L12.913 8.875c-.796-.443-1.413-.355-1.856.088l11.048 10.975 3.712-3.717h.002z"
                    fill="#000"
                />
                <path
                    opacity={0.2}
                    d="M25.733 23.567l-12.817 7.258c-.707.442-1.325.355-1.767 0l-.088.089.088.087c.441.355 1.06.444 1.767 0l12.817-7.434z"
                    fill="#000"
                />
                <path
                    opacity={0.12}
                    d="M11.063 30.825c-.266-.266-.354-.709-.354-1.239v.088c0 .531.177.975.442 1.24v-.089h-.088zm19.09-9.736l-4.42 2.479.088.087 4.331-2.478c.62-.353.884-.796.884-1.238 0 .442-.354.796-.884 1.15z"
                    fill="#000"
                />
                <path
                    opacity={0.25}
                    d="M12.918 8.963l17.235 9.825c.53.353.883.707.883 1.15 0-.443-.265-.886-.884-1.238L12.918 8.875c-1.237-.709-2.21-.089-2.21 1.326v.089c0-1.416.973-2.035 2.21-1.327z"
                    fill="#000"
                />
                <path
                    d="M9.313 6.884l16.97 18.306zm.412 25.611l16.557-16.532z"
                    fill="#000"
                />
                <path
                    d="M9.313 6.884l16.97 18.306M9.724 32.495l16.557-16.532"
                    stroke="#fff"
                    strokeWidth={0.52}
                />
            </svg>
        );
    }

    function IconAppGallery(props) {
        return (
            <svg
                width={120}
                height={38}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <mask
                    id="prefix__a"
                    style={{
                        maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x={10}
                    y={7}
                    width={22}
                    height={23}
                >
                    <path d="M10 7.819h21.926v21.926H10V7.819z" fill="#fff" />
                </mask>
                <g mask="url(#prefix__a)">
                    <path
                        d="M27.179 7.933H14.823a4.675 4.675 0 00-4.675 4.675v12.356a4.675 4.675 0 004.675 4.675h12.356a4.675 4.675 0 004.675-4.675V12.608a4.675 4.675 0 00-4.675-4.675z"
                        fill="#000"
                    />
                    <path
                        d="M15.439 9.35a.619.619 0 00-.435 1.053.613.613 0 00.436.178.62.62 0 00.57-.851.613.613 0 00-.571-.38zm11.046 0a.619.619 0 00-.435 1.053.613.613 0 00.436.178.619.619 0 00.57-.851.616.616 0 00-.571-.38z"
                        fill="#fff"
                    />
                    <path
                        d="M15.415 9.881c-.215.013-.204.325-.204.325 1.153 2.245 3.277 3.347 5.725 3.347 2.447-.004 4.591-1.118 5.744-3.36 0 0 .045-.423-.405-.275-1.18 1.957-3.165 3.115-5.337 3.118-2.175 0-4.152-1.145-5.335-3.107a.392.392 0 00-.188-.048zm7.805 8.73l-.655 1.955-.639-1.952h-.625l1.008 2.84h.485l.659-1.867.656 1.867h.49l1.003-2.84h-.607l-.64 1.952-.656-1.953h-.479v-.002zm-3.485.002l-1.273 2.84h.6l.244-.55.018-.042h1.322l.26.591h.615L20.26 18.63l-.012-.017h-.512zm9.221 0v2.837h.579v-2.837h-.579zm-16.59 0v2.842h.588v-1.154h1.323v1.154h.587v-2.841h-.588v1.146h-1.323v-1.146l-.587-.002zm5.213 0v1.627c0 .463-.235.709-.658.709-.426 0-.662-.253-.662-.728v-1.605h-.585v1.625c0 .8.451 1.258 1.24 1.258.793 0 1.25-.468 1.25-1.281v-1.605h-.587.002zm8.496.002v2.838h2.183v-.517h-1.604v-.703h1.066v-.52h-1.066v-.58h1.549v-.518h-2.128zm-6.091.716l.418.953.028.065h-.887l.028-.065.413-.953z"
                        fill="#fff"
                    />
                </g>
                <path
                    d="M45.24 15.2c-.731.724-1.63 1.085-2.698 1.085-1.067 0-1.97-.363-2.707-1.085-.731-.724-1.096-1.622-1.096-2.697 0-1.082.369-1.98 1.107-2.697.738-.723 1.638-1.085 2.697-1.085 1.06 0 1.958.361 2.697 1.085.737.717 1.106 1.615 1.106 2.697 0 1.075-.368 1.973-1.106 2.697zm-.593-4.835a2.847 2.847 0 00-2.105-.876c-.825 0-1.527.291-2.105.876a2.927 2.927 0 00-.866 2.137c0 .842.289 1.554.867 2.138a2.849 2.849 0 002.104.877c.825 0 1.528-.292 2.105-.876a2.928 2.928 0 00.867-2.137c0-.841-.289-1.554-.867-2.138v-.001zm5.976 1.963h-1.425v3.825h-.79v-3.825h-1.425v-.724h3.638l.002.724zm.828-.724h.789v1.864l1.843-1.863h.965l-1.974 2.027 2.215 2.522h-1.032l-1.774-1.995-.243.23v1.765h-.789v-4.55zm5.414 3.914v3.157h-.789v-7.071h.789v.636a1.912 1.912 0 011.557-.746c.68 0 1.217.241 1.613.725.4.475.601 1.037.601 1.687 0 .658-.196 1.22-.591 1.688-.395.461-.925.691-1.59.691s-1.195-.256-1.59-.768zm1.48.066c.446 0 .805-.162 1.075-.483.27-.329.405-.727.405-1.195 0-.526-.15-.942-.45-1.25a1.411 1.411 0 00-1.04-.46c-.395 0-.746.154-1.053.46-.307.308-.46.72-.46 1.239 0 .475.138.878.417 1.206.285.321.654.483 1.106.483zm7.35.021c-.454.454-1.027.68-1.721.68-.695 0-1.273-.226-1.733-.68-.452-.453-.68-1.023-.68-1.71 0-.694.228-1.268.68-1.721.46-.453 1.038-.68 1.733-.68.694 0 1.267.227 1.721.68.46.454.69 1.027.69 1.721 0 .688-.23 1.258-.69 1.71zm-.592-2.96a1.556 1.556 0 00-1.13-.45c-.445 0-.824.155-1.14.463-.307.298-.46.712-.46 1.237 0 .526.157.94.47 1.239.316.3.692.45 1.13.45.438 0 .816-.15 1.13-.45.315-.3.47-.713.47-1.238 0-.535-.155-.951-.47-1.251zm2.493-1.041h.789v3.004l3.115-3.354v4.9h-.789v-3.038l-3.114 3.355v-4.867zm.394-1.963l.659-.251c.131.438.441.657.931.657.49 0 .8-.22.933-.657l.657.251c-.11.32-.322.593-.604.779a1.704 1.704 0 01-.986.285c-.38 0-.712-.095-.998-.285a1.544 1.544 0 01-.592-.779zm7.984 2.687h-1.425v3.825h-.79v-3.825h-1.425v-.724h3.64v.724zm4.1 2.302l.656.362a2.63 2.63 0 01-.559.734 2.189 2.189 0 01-1.512.559 2.324 2.324 0 01-1.59-.591c-.438-.403-.658-.999-.658-1.788 0-.695.198-1.267.591-1.721.403-.46.94-.691 1.613-.691.76 0 1.334.279 1.721.834.306.437.45 1.008.428 1.71h-3.541c.007.46.15.833.427 1.118.277.285.617.428 1.02.428.358 0 .669-.11.931-.329.205-.175.364-.384.473-.625zm-2.796-1.25h2.674a1.42 1.42 0 00-.472-.855 1.242 1.242 0 00-.865-.329c-.33 0-.621.113-.877.34-.25.219-.403.5-.46.844zm7.254-1.775h1.722c.417 0 .735.088.953.262.263.213.396.497.396.855a1.02 1.02 0 01-.494.91c.227.058.417.16.57.307.241.233.362.526.362.877 0 .438-.157.783-.471 1.03-.271.205-.629.308-1.075.308h-1.963v-4.55.001zm.79 1.851h.833c.213 0 .38-.043.505-.131a.555.555 0 00.219-.471.52.52 0 00-.219-.438c-.11-.075-.322-.11-.636-.11h-.701v1.15zm0 1.997h.975c.338 0 .576-.052.713-.154a.606.606 0 00.262-.505.626.626 0 00-.228-.515c-.139-.11-.376-.164-.713-.164h-1.008v1.338zM44.833 28.4l-.74-1.754h-3.37l-.74 1.754h-1.767l3.596-8.357h1.278l3.496 8.357h-1.754zm-3.597-3.082h2.38l-1.19-3.007-1.19 3.006zm7.629 2.38v3.57h-1.529v-8.293h1.529v.701c.409-.585.997-.876 1.766-.876.752 0 1.37.241 1.855.725.543.544.814 1.263.814 2.156 0 .919-.284 1.65-.852 2.193-.5.467-1.116.701-1.842.701a2.062 2.062 0 01-1.741-.876zm1.352-3.546a1.42 1.42 0 00-.989.363c-.342.294-.513.681-.513 1.166 0 .493.166.885.5 1.178.276.242.61.362 1.002.362.41 0 .753-.128 1.028-.387.317-.293.476-.677.476-1.153 0-.467-.154-.847-.462-1.14a1.488 1.488 0 00-1.042-.389zM56.01 27.7v3.57H54.48v-8.294h1.529v.701c.41-.585.998-.876 1.767-.876.752 0 1.369.241 1.854.725.542.544.814 1.263.814 2.156 0 .919-.284 1.65-.852 2.193-.5.467-1.114.701-1.842.701a2.064 2.064 0 01-1.741-.876zm1.353-3.547c-.392 0-.722.122-.99.363-.342.294-.513.681-.513 1.166 0 .493.167.885.5 1.178.276.242.611.362 1.003.362.41 0 .752-.128 1.028-.387.318-.293.475-.677.475-1.153 0-.467-.154-.847-.462-1.14a1.489 1.489 0 00-1.04-.389zm8.726 1.178v-1.402h3.832v.1c0 1.495-.409 2.647-1.228 3.457-.734.735-1.724 1.102-2.97 1.102-1.268 0-2.28-.375-3.03-1.127-.828-.826-1.24-1.9-1.24-3.22 0-1.252.408-2.287 1.227-3.107.835-.852 1.933-1.278 3.295-1.278.735 0 1.377.146 1.928.438.644.326 1.167.837 1.567 1.53l-1.415.763a2.281 2.281 0 00-.978-.99 2.6 2.6 0 00-1.177-.262c-.785 0-1.429.246-1.93.739-.559.542-.839 1.278-.839 2.204 0 .878.275 1.584.826 2.118.493.476 1.111.715 1.855.715.65 0 1.199-.168 1.641-.501.4-.31.663-.735.79-1.279h-2.154zm9.266-1.654v-.701h1.528V28.4h-1.528v-.701c-.409.583-.965.876-1.666.876-.82 0-1.488-.28-2.005-.839-.51-.56-.764-1.245-.764-2.055 0-.819.25-1.504.751-2.055.501-.55 1.15-.826 1.942-.826.785 0 1.366.291 1.742.876zm-.275.915A1.436 1.436 0 0074 24.154a1.435 1.435 0 00-1.077.437c-.285.293-.427.655-.427 1.09 0 .434.142.802.425 1.103.285.292.644.437 1.08.437.433 0 .792-.145 1.077-.437.284-.3.425-.669.425-1.103 0-.435-.142-.797-.425-1.09zm3.261-5.325h1.529V28.4H78.34v-9.134zm2.985 0h1.529V28.4h-1.529v-9.134zm6.907 7.393l1.403.225c-.058.15-.138.3-.238.451a4.253 4.253 0 01-.437.539 2.24 2.24 0 01-.815.512 3.396 3.396 0 01-1.179.189c-.851 0-1.545-.254-2.078-.764-.57-.535-.853-1.24-.853-2.117 0-.869.275-1.579.828-2.13.517-.51 1.197-.764 2.04-.764.92 0 1.626.296 2.118.889.435.518.653 1.227.653 2.13v.125h-4.062c0 .367.088.672.263.915.25.342.615.513 1.091.513.568 0 .99-.237 1.267-.713zm-2.568-1.691h2.569c-.06-.352-.213-.62-.464-.803a1.328 1.328 0 00-1.654 0 1.25 1.25 0 00-.451.803zm5.192 3.432v-5.425h1.529v.814c.184-.35.41-.6.676-.752.25-.158.551-.237.903-.237.2 0 .417.041.651.125l-.2 1.427a1.22 1.22 0 00-.714-.2c-.444 0-.781.147-1.015.438-.2.251-.3.652-.3 1.204V28.4h-1.53zm4.782 2.869l1.992-3.684-2.581-4.61h1.78l1.678 3.082 1.504-3.082h1.729l-4.372 8.294h-1.73z"
                    fill="#000"
                />
            </svg>
        );
    }

    function IconRuStore(props) {
        return (
            <svg
                width={120}
                height={38}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M26.637 24.744l2.17.542a1.554 1.554 0 001.934-1.502V13.332c0-.888-.607-1.661-1.471-1.877L23.05 9.9a1.554 1.554 0 00-1.935 1.501v1.885l-3.92-.98a1.554 1.554 0 00-1.934 1.502v1.884l-3.919-.979a1.554 1.554 0 00-1.935 1.502v10.452c0 .887.607 1.661 1.472 1.877l6.22 1.554a1.554 1.554 0 001.934-1.502l.002-10.438c0-.882-.558-1.392-.76-1.549a.093.093 0 01-.022-.125.11.11 0 01.122-.045c.82.248 1.604 1.088 1.682 2.144l.27 7.983c.01.262.18.49.423.575l2.203.55a1.554 1.554 0 001.934-1.501l.002-10.436a1.97 1.97 0 00-.76-1.55.094.094 0 01-.021-.126.11.11 0 01.122-.044c.82.247 1.604 1.087 1.682 2.144l.27 7.982c.01.273.194.507.455.583zM52.244 32.667H50.01l-3.546-4.95h-1.866v4.95h-1.902v-13.02h4.58c.887 0 1.68.172 2.383.517.701.345 1.243.825 1.625 1.44.394.604.59 1.3.59 2.087 0 .985-.3 1.829-.904 2.53-.603.69-1.41 1.145-2.42 1.367l3.694 5.079zM44.598 21.4v4.58h2.678c.788 0 1.422-.209 1.902-.628.493-.43.74-.985.74-1.662 0-.677-.247-1.225-.74-1.643-.48-.431-1.114-.647-1.902-.647h-2.678zm12.694 11.45a3.425 3.425 0 01-1.829-.498 3.6 3.6 0 01-1.274-1.404c-.308-.603-.462-1.28-.462-2.031v-5.8h1.81v5.652c0 .726.203 1.317.61 1.773.406.455.929.683 1.57.683.664 0 1.218-.234 1.661-.702.444-.468.665-1.052.665-1.754v-5.651h1.81v9.548H60.56l-.424-1.44a3.254 3.254 0 01-1.22 1.2 3.202 3.202 0 01-1.624.424zm11.308 0c-1.194 0-2.234-.307-3.121-.923-.874-.628-1.471-1.477-1.791-2.549l1.828-.295c.357.69.782 1.2 1.274 1.533.493.32 1.096.48 1.81.48.727 0 1.318-.16 1.773-.48.456-.333.683-.782.683-1.349 0-.418-.129-.769-.387-1.052a2.698 2.698 0 00-.942-.684c-.382-.172-.88-.363-1.496-.572-.825-.27-1.502-.542-2.032-.813a3.878 3.878 0 01-1.348-1.144c-.357-.505-.535-1.145-.535-1.921 0-.727.178-1.36.535-1.902.37-.554.874-.98 1.514-1.275.64-.295 1.355-.443 2.143-.443 1.096 0 2.037.29 2.825.868.788.566 1.349 1.348 1.68 2.346l-1.79.295c-.247-.566-.598-.997-1.053-1.293-.456-.308-.991-.462-1.607-.462-.665 0-1.213.16-1.644.48-.43.308-.646.733-.646 1.275 0 .406.123.751.37 1.034.258.283.572.511.941.684.382.172.887.369 1.515.59.8.271 1.465.548 1.994.831a3.76 3.76 0 011.367 1.164c.37.505.554 1.139.554 1.902 0 .739-.197 1.385-.591 1.94-.382.553-.911.984-1.588 1.292-.665.296-1.41.443-2.235.443zm12.059-1.773l-.166 1.589h-1.68c-.998 0-1.755-.247-2.272-.739-.517-.492-.776-1.2-.776-2.124v-5.078h-1.644v-1.607h1.644l.499-2.77h1.31v2.77h2.919v1.607h-2.918v5.078c0 .85.412 1.274 1.237 1.274h1.847zm6.035 1.773c-.972 0-1.84-.209-2.603-.627a4.546 4.546 0 01-1.792-1.755c-.43-.751-.646-1.607-.646-2.567 0-.96.215-1.816.646-2.567a4.546 4.546 0 011.792-1.755c.763-.43 1.63-.646 2.603-.646.973 0 1.841.215 2.604.646a4.547 4.547 0 011.792 1.755c.43.75.646 1.607.646 2.567 0 .96-.215 1.816-.646 2.567a4.547 4.547 0 01-1.792 1.755c-.763.418-1.63.627-2.604.627zm0-1.662c.936 0 1.693-.301 2.272-.905.591-.603.886-1.397.886-2.382 0-.985-.295-1.78-.886-2.382-.579-.616-1.336-.924-2.272-.924-.935 0-1.692.308-2.271.924-.579.603-.868 1.397-.868 2.382 0 .973.29 1.767.868 2.382.579.604 1.336.905 2.271.905zm6.983 1.478v-9.548h1.311l.388 1.366c.283-.48.634-.825 1.053-1.034.418-.221.917-.332 1.496-.332h.443l.148 1.736H97.48c-.664 0-1.163.19-1.495.572-.333.382-.499.899-.499 1.552v5.688h-1.81zm15.186-4.839c0 .246-.007.437-.019.573h-7.886c.099.85.431 1.526.998 2.031.566.505 1.286.757 2.16.757.604 0 1.139-.117 1.607-.35.48-.247.843-.567 1.09-.961l1.699.277a4.096 4.096 0 01-1.792 1.995c-.812.468-1.717.701-2.715.701-.948 0-1.797-.209-2.548-.627a4.58 4.58 0 01-1.754-1.773c-.42-.752-.628-1.601-.628-2.549 0-.96.209-1.816.628-2.567a4.486 4.486 0 011.736-1.755c.738-.43 1.582-.646 2.53-.646.935 0 1.772.215 2.511.646a4.458 4.458 0 011.755 1.755c.418.739.628 1.57.628 2.493zm-4.894-3.287c-.727 0-1.355.215-1.884.646-.517.431-.862 1.01-1.034 1.736h5.836c-.161-.714-.505-1.286-1.035-1.717-.517-.444-1.145-.665-1.883-.665zM42.668 15.801v-2.353h.155c.201 0 .362-.05.483-.147.12-.098.221-.293.302-.586.086-.299.152-.739.198-1.32l.25-3.206h3.828v5.259h.888V15.8h-.888v-1.534h-4.328V15.8h-.888zm4.328-2.353v-4.44h-2.121l-.181 2.431c-.07.971-.247 1.64-.535 2.009h2.837zm4.598.905c-.454 0-.859-.098-1.215-.293a2.123 2.123 0 01-.837-.82 2.365 2.365 0 01-.301-1.198c0-.448.1-.847.301-1.198.202-.35.48-.623.837-.819a2.43 2.43 0 011.215-.302c.454 0 .86.101 1.216.302.356.195.635.468.836.82.201.35.302.75.302 1.197 0 .449-.1.848-.302 1.199-.201.35-.48.623-.836.819a2.486 2.486 0 01-1.216.293zm0-.776c.437 0 .79-.14 1.06-.422.276-.282.414-.653.414-1.113 0-.46-.137-.83-.413-1.112-.27-.287-.624-.43-1.06-.43-.438 0-.791.143-1.061.43-.27.282-.405.653-.405 1.112 0 .454.135.825.405 1.113.27.281.623.422 1.06.422zm5.312.776a2.45 2.45 0 01-1.199-.293 2.137 2.137 0 01-.819-.828 2.402 2.402 0 01-.293-1.19c0-.448.098-.847.293-1.198.196-.35.469-.623.82-.819.35-.201.75-.302 1.198-.302.477 0 .902.115 1.275.345.38.23.65.56.81.992l-.792.129a1.177 1.177 0 00-.492-.5 1.47 1.47 0 00-.75-.19c-.437 0-.793.144-1.069.431-.27.288-.405.658-.405 1.112 0 .454.135.825.405 1.113.276.281.633.422 1.07.422.292 0 .551-.066.775-.198a1.19 1.19 0 00.5-.526l.793.13a1.958 1.958 0 01-.827 1.016 2.429 2.429 0 01-1.293.354zm4.729-.086h-.845v-3.681h-1.543V9.81h3.931v.775h-1.543v3.682zm5.534-4.457h.871l-1.862 5.13c-.138.384-.32.663-.543.835-.224.173-.523.259-.897.259h-.664l-.077-.776h.793c.167 0 .296-.037.388-.112.092-.069.17-.193.233-.37l.094-.26-1.982-4.706h.905l1.414 3.44h.12l1.207-3.44zm2.48 4.457h-.845V9.81h3.793v4.457h-.845v-3.681H69.65v3.68zm7.105-2.638v-1.82h.845v4.458h-.845v-1.862h-2.146v1.862h-.845V9.81h.845v1.819h2.146zm4.105 2.724c-.454 0-.86-.098-1.216-.293a2.121 2.121 0 01-.836-.82 2.364 2.364 0 01-.302-1.198c0-.448.1-.847.302-1.198.2-.35.48-.623.836-.819a2.43 2.43 0 011.216-.302c.454 0 .859.101 1.215.302.356.195.635.468.836.82.201.35.302.75.302 1.197 0 .449-.1.848-.302 1.199-.2.35-.48.623-.836.819a2.485 2.485 0 01-1.215.293zm0-.776c.436 0 .79-.14 1.06-.422.276-.282.414-.653.414-1.113 0-.46-.138-.83-.414-1.112-.27-.287-.624-.43-1.06-.43-.437 0-.79.143-1.06.43-.271.282-.406.653-.406 1.112 0 .454.135.825.405 1.113.27.281.624.422 1.06.422zm8.287-1.647c.23.087.414.227.552.423.144.19.216.414.216.672 0 .236-.07.448-.207.638-.133.19-.32.34-.56.448a2.084 2.084 0 01-.829.156H86.19V9.81h2.052c.293 0 .555.051.784.155.23.103.409.244.535.422.132.178.198.382.198.612a.989.989 0 01-.163.57 1.013 1.013 0 01-.449.361zm-2.112-1.405v1.095h1.207a.766.766 0 00.483-.146.49.49 0 00.19-.397.49.49 0 00-.19-.397.738.738 0 00-.483-.155h-1.207zm1.284 3.026c.225 0 .406-.057.544-.172a.556.556 0 00.207-.449.556.556 0 00-.207-.448c-.138-.115-.32-.172-.543-.172h-1.285v1.241h1.284z"
                    fill="#000"
                />
            </svg>
        );
    }

    const indexFooter = (props) => {
        const {stores = {}, authCheck = false, user = {}, ratingYandexMarket} = props
        const {
            searchStore = {},
            // subscribeNewsletterStore = {},
            filterStore = {},
            rightMenuStore = {},
            subMenuStore = {},
            basketStore = {},
            favouritesStore = {}
        } = stores;
        const year = new Date();
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        const isIos = useMemo(() => {
            return [
                'iPhone Simulator',
                'iPhone'
            ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        }, []);

        const active_orders = getProperty(user, 'ordersCount', 0) + getProperty(user, 'returnOrdersCount', 0);

        return <>
            <footer className={`footer`}>
                {location.pathname !== '/go-to-checkout' && (
                    <>
                        <div className={`container`}>
                            <div className={`footer__nav`}>
                                {isMobile() ?
                                    <FooterNavMobile {...props} />
                                    :
                                    <>
                                        <div className={`footer__item`}>
                                            <LinkLoad href={`/about-company`} className={`link-title`}>
                                                О компании
                                            </LinkLoad>
                                            <LinkLoad href={`/news`} className={`link-item`}>
                                                Новости и пресс-релизы
                                            </LinkLoad>
                                            <LinkLoad href={`/jobs`} className={`link-item`}>
                                                Вакансии
                                            </LinkLoad>
                                            <LinkLoad href={`/philosophy`} className={`link-item`}>
                                                Философия
                                            </LinkLoad>
                                            <LinkLoad href={`/contacts`} className={`link-item`}>
                                                Контакты
                                            </LinkLoad>
                                            <div className={`link-item`}>
                                                &nbsp;
                                            </div>
                                            <LinkLoad href={`/polzovatelskoe-soglashenie`} className={`link-item`}>
                                                Пользовательское соглашение
                                            </LinkLoad>
                                            <LinkLoad href={`/politika-konfidencialnosti`} className={`link-item`}>
                                                Политика конфиденциальности
                                            </LinkLoad>
                                            <LinkLoad href={`/sitemap`} className={`link-item`}>
                                                Карта сайта
                                            </LinkLoad>
                                        </div>
                                        <div className={`footer__item`}>
                                            <LinkLoad href={`/catalog`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-title`}>
                                                Украшения
                                            </LinkLoad>
                                            <LinkLoad href={`/catalog`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-item`}>
                                                Каталог
                                            </LinkLoad>
                                            <LinkLoad href={`/catalog/kolca`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-item`}>
                                                Кольца
                                            </LinkLoad>
                                            <LinkLoad href={`/catalog/sergi`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-item`}>
                                                Серьги
                                            </LinkLoad>
                                            <LinkLoad href={`/catalog/podveski`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-item`}>
                                                Подвески
                                            </LinkLoad>
                                            <LinkLoad href={`/catalog/broshi`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-item`}>
                                                Броши
                                            </LinkLoad>
                                            <LinkLoad href={`/catalog/cepi`}
                                                      onClick={() => filterStore.handleClickLink()}
                                                      className={`link-item`}>
                                                Цепи
                                            </LinkLoad>
                                        </div>
                                        <div className={`footer__item`}>
                                            <LinkLoad href={`/b2b`}
                                                      className={`link-title`}>
                                                Партнерам
                                            </LinkLoad>
                                            <a href={`https://b2b.platina-kostroma.com/web-create-account`}
                                               className={`link-item`}
                                               target={`_blank`}>
                                                Стать партнёром
                                            </a>
                                            <a href={`https://b2b.platina-kostroma.com/web-login`}
                                               className={`link-item`}
                                               target={`_blank`}>
                                                Личный кабинет партнера
                                            </a>
                                        </div>
                                        <div className={`footer__item`}>
                                            <div className={`link-title`}>
                                                Покупателям
                                            </div>
                                            <LinkLoad href={`/gift-certificate`} className={`link-item`}>
                                                Подарочные сертификаты
                                            </LinkLoad>
                                            <LinkLoad href={`/platina-benefits`} className={`link-item`}>
                                                Бонусная программа
                                            </LinkLoad>
                                            <LinkLoad href={`/sber-credit-terms`} className={`link-item`}>
                                                Условия кредитования и рассрочки
                                            </LinkLoad>
                                            <LinkLoad href={`/dolyame`} className={`link-item`}>
                                                Покупка долями
                                            </LinkLoad>
                                            <LinkLoad href={`/split`} className={`link-item`}>
                                                Покупка в сплит
                                            </LinkLoad>
                                            <LinkLoad href={`/delivery`} className={`link-item`}>
                                                Оплата и доставка
                                            </LinkLoad>
                                            <LinkLoad href={`/vozvrat-tovara`} className={`link-item`}>
                                                Возврат товара
                                            </LinkLoad>
                                            <LinkLoad href={`/quality-guarantee`} className={`link-item`}>
                                                Гарантии качества
                                            </LinkLoad>
                                            <LinkLoad href={`/faq`} className={`link-item`}>
                                                FAQ
                                            </LinkLoad>

                                        </div>
                                    </>
                                }
                                <div className={`footer__item footer__item_logo`}>
                                    <LinkLoad href="/" className={`logoBox`}>
                                        <Svg id={`main-logo-new`} className={`svg__main-logo`} />
                                    </LinkLoad>
                                    <div className={`phone-box`}>
                                        <div className={`phone-box__number`}>
                                            <span className={`text`}>WhatsApp, Telegram</span>
                                            {/*<span className={`text`}>Viber, WhatsApp, Telegram</span>*/}
                                            <a className={`footerPhone`}
                                               onClick={() => {
                                                   reachGoalYM('phone_click');
                                                   reachGoalGA('phone_click');
                                               }}
                                               href="tel:+79109522022">+7 910 952-20-22</a>
                                            <div className={`phone-box__message`}>
                                                {/*<div className={`phone-box__viber`}>*/}
                                                {/*    <a href={`viber://chat?number=%2B79109522022`}>*/}
                                                {/*        <Svg id={`viber`} className={`svg__viber`} />*/}
                                                {/*    </a>*/}
                                                {/*</div>*/}
                                                <div className={`phone-box__whatsapp`}>
                                                    <a href="https://wa.me/79109522022">
                                                        <Svg id={`whatsapp`} className={`svg__whatsapp`} />
                                                    </a>
                                                </div>
                                                <div className={`phone-box__telegram`}>
                                                    <a href="https://t.me/platina_jewelry_chat">
                                                        <Svg id={`telegram`} className={`svg__telegram`} />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`social-box__title`}>
                                        Мы в социальных сетях
                                    </div>
                                    <div className={`social-box`}>
                                        <div className={`social-box__item`}>
                                            <a href="https://vk.com/platina_kostroma"
                                               rel="noopener noreferrer"
                                               target={`_blank`}>
                                                <Svg id={`vk`} className={`svg__vk`} />
                                            </a>
                                        </div>
                                        <div className="social-box__item">
                                            <a href="https://ok.ru/platina.kostroma"
                                               rel="noopener noreferrer"
                                               target={`_blank`}>
                                                <Svg id={`ok`} className={`svg__ok`} />
                                            </a>
                                        </div>
                                        <div className="social-box__item">
                                            <a href="https://www.youtube.com/c/PlatinaJewelry"
                                               rel="noopener noreferrer"
                                               target={`_blank`}>
                                                <Svg id={`yt`} className={`svg__yt`} />
                                            </a>
                                        </div>
                                        <div className="social-box__item">
                                            <a href="https://t.me/platina_jewelry"
                                               rel="noopener noreferrer"
                                               target={`_blank`}>
                                                <Svg id={`telegram`} className={`svg__telegram`} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`footer__line`}></div>
                        <div className={`container`}>
                            <div className={`footer footer__apps`}>
                                {/*<a href={`https://yandex.ru/maps/org/platina/1065302747/reviews`}*/}
                                <a href={`https://reviews.yandex.ru/shop/platina-kostroma.com`}
                                   className={`yaMarket`}
                                   target={`_blank`}
                                >
                                    <div className={`yaMarket__icon`}>
                                        <Svg id={`yandex-reviews`} className={`svg__yandexMarket`} />
                                    </div>
                                    <div className={`yaMarket__rating`}>
                                        <p className={`count`}>{ratingYandexMarket}</p>
                                        <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                        <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                        <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                        <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                        <Svg id={`yandex-market-star`} className={`svg__yandexMarketStar`} />
                                    </div>
                                </a>
                                <div className={`followApps`}>
                                    <a href="https://apps.apple.com/ru/app/platina-%D0%BC%D0%B0%D0%B3%D0%B0%D0%B7%D0%B8%D0%BD-%D1%83%D0%BA%D1%80%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B9/id6450421426"
                                       className={`followApps__item`}
                                       target={`_blank`}>
                                        <Svg id={`app-store`} className={`svg__appStore`} />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.platinakostroma.androidapp"
                                       className={`followApps__item`}
                                       target={`_blank`}>
                                        <IconGooglePlay />
                                    </a>
                                    <a href="https://appgallery.huawei.com/app/C106976539"
                                       className={`followApps__item`}
                                       target={`_blank`}>
                                        <IconAppGallery />
                                    </a>
                                    <a href="https://www.rustore.ru/catalog/app/com.platinakostroma.androidapp"
                                       className={`followApps__item`}
                                       target={`_blank`}>
                                        <IconRuStore />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className={`footer__line`}></div>
                    </>
                )}
                <div className={`footer footer__year`}>
                    <div className={`container`}>
                        <p>&copy;&nbsp;ЮЗ&nbsp;&laquo;ПЛАТИНА&raquo;, {year.getFullYear()}</p>
                    </div>
                </div>
            </footer>
            {
                (isMobile() && searchStore.onfocus) ?
                    <>
                        <PWA />
                        <div className={`bottom-nav`}>
                            <div className={`bottom-nav__wrapper`}>
                                {isIos && isInStandaloneMode() && (
                                    <div className={`bottom-nav__item`}
                                         onClick={() => window.history.back()}>
                                        <div className={`bottom-nav__icon`}>
                                            <Svg id={`arrows-left`} className={`svg__home`} />
                                        </div>
                                        <p className={`bottom-nav__title`}>Назад</p>
                                    </div>
                                )}
                                <LinkLoad href={`/`}
                                          onClick={() => {
                                              subMenuStore.closeMobileSubMenu()
                                              rightMenuStore.closeRightMenu()
                                          }}
                                          className={`bottom-nav__item`}>
                                    <p className={`bottom-nav__icon`}>
                                        <Svg id={`homeRoundedIcon`} className={`svg__home`} />
                                    </p>
                                    <p className={`bottom-nav__title`}>Главная</p>
                                </LinkLoad>
                                <div className={`bottom-nav__item`}
                                     onClick={() => {
                                         subMenuStore.changeMobileSubMenu()
                                         rightMenuStore.closeRightMenu()
                                     }}>
                                    <p className={`bottom-nav__icon`}>
                                        <Svg id={`catalog`} className={`svg__home`} />
                                    </p>
                                    <p className={`bottom-nav__title`}>
                                        Каталог
                                    </p>
                                </div>
                                <LinkLoad href={`/favorites`}
                                          onClick={() => {
                                              subMenuStore.closeMobileSubMenu()
                                              rightMenuStore.closeRightMenu()
                                          }}
                                          className={`bottom-nav__item`}>
                                    <p className={`bottom-nav__icon bottom-nav__icon_favorites`}>
                                        <Svg id={`favoriteBorderOutlinedIcon`} className={`svg__heart`} />
                                        {favouritesStore.favouritesData.length !== 0 && (
                                            <span className={`bottom-nav__icon_dots`}></span>
                                        )}
                                    </p>
                                    <p className={`bottom-nav__title`}>Избранное</p>
                                </LinkLoad>
                                <LinkLoad href={`/basket`}
                                          method={`post`}
                                          as={'button'}
                                          data={{
                                              paymentMethod: basketStore.valuePaymentMethod,
                                              // flagBonusesPromoCod: basketStore.flagBonusesPromoCod,
                                              // promoCodeValue: basketStore.promo_id,
                                              promoCodeValue: basketStore.promoCodeValues,
                                              certificateData: basketStore.certificateData,
                                              // deliveryData: basketStore.deliveryData,
                                              bonuses: basketStore.subtractBonuses,
                                          }}
                                          onClick={() => {
                                              rightMenuStore.closeRightMenu()
                                              subMenuStore.closeMobileSubMenu()
                                          }}
                                          className={`bottom-nav__item inertiaButton`}>
                                    <p className={`bottom-nav__icon`}>
                                        <Svg id={`basketBlack`} className={`svg__basketBlack`} />
                                        {basketStore.basketCount !== 0 &&
                                            <span className={`basket-count`}>{basketStore.basketCount}</span>}
                                    </p>
                                    <p className={`bottom-nav__title`}>Корзина</p>
                                </LinkLoad>
                                <div className={`bottom-nav__item`}
                                     onClick={() => {
                                         rightMenuStore.openRightMenu();
                                         subMenuStore.closeMobileSubMenu()
                                     }}>
                                    <div className={`bottom-nav__icon bottom-nav__profile`}>
                                        <Svg id={`profileBlack`} className={`svg__profileBlack`} />
                                        {authCheck && active_orders !== 0 && (
                                            <span className={`profileDots`}></span>
                                        )}
                                    </div>
                                    <p className={`bottom-nav__title`}>Профиль</p>
                                </div>
                            </div>
                        </div>
                    </> : ''
            }
        </>
    };

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <link rel="canonical" href={pathCanonical} />
                <meta name="robots" content={robots} />
            </Head>

            <div id={`bodyWrapper`} className={`bodyWrapper`}>
                {!mobileApp && (
                    <>
                        {isDesktop() ?
                            <>
                                <HeaderDesktop {...props} />
                                {navDesktop(props)}
                            </> :
                            headerMobile(props)
                        }
                    </>
                )}
                {children}
                {!mobileApp && (
                    indexFooter(props)
                )}
            </div>
            <ModalWindowsComponent {...props} />
        </>
    );
}

const MainSale = (props) => {
    const {mainSale = {}} = props;
    const [headerMainSale, setHeaderMainSale] = useState(sessionStorage.getItem('headerMainSale'));

    /**
     * Закрыть главную акцию
     */
    const closeMainSale = () => {
        sessionStorage.setItem('headerMainSale', '1');
        setHeaderMainSale(sessionStorage.getItem('headerMainSale'));
    }

    if (headerMainSale !== null || mainSale === null) {
        return null;
    }
    const {img_main_sale = '', img_main_sale_mobile = '', title = '', alias = ''} = mainSale;

    return <div id={`stickyMainSale`} className={`headerMainSale`}>
        <div className={`headerMainSale__cross`} onClick={() => closeMainSale()}>
            <Svg id={`dagger-close`} className={`svg__dagger-close svg__dagger-close_mainSale`} />
        </div>
        <LinkLoad href={`/stocks/${alias}`}>
            <picture>
                <source type={`image/webp`}
                        srcSet={img_main_sale_mobile.replace('.png', '.webp').replace('.jpg', '.webp').replace('.jpeg', '.webp')}
                        media="(max-width: 767px)"
                />
                <source type={`image/webp`}
                        srcSet={img_main_sale.replace('.png', '.webp').replace('.jpg', '.webp').replace('.jpeg', '.webp')}
                />
                <source srcSet={img_main_sale_mobile} media="(max-width: 767px)" />
                <img src={img_main_sale} alt={title} />
            </picture>
        </LinkLoad>
    </div>
}

const HeaderDesktop = (props) => {
    const {stores = {}, authCheck = false, user = {}} = props;
    const {
        rightMenuStore = {},
        basketStore = {},
        favouritesStore = {},
        mobileMenuStore = {},
        subMenuStore = {}
    } = stores;

    // const openClass = useMemo(() => {
    //     return classNames('headerBox__catalog', props.className, {
    //         'open': subMenuStore.open,
    //     });
    // }, [props.className, subMenuStore.open]);

    const openClass = classNames('headerBox__catalog', props.className, {
        'open': subMenuStore.open,
    });

    const active_orders = getProperty(user, 'ordersCount', 0) + getProperty(user, 'returnOrdersCount', 0);

    return (
        <header id={`header`} className={`header`}>
            <MainSale {...props} />
            <div className={`headerBox`}>
                <div>
                    <div className={`container`}>
                        <div className={`headerBox__item headerBox__item_notSticky`}>
                            {isDesktop() ? <Country {...props} /> :
                                <p className={`p-10`}
                                   onClick={() => mobileMenuStore.openMobileMenu()}>
                                    <Svg id={`mobile-menu`} className={`svg__mobile-menu`} />
                                </p>
                            }
                            <SelectCity {...props} />
                            <div className={`headerBox__phones`}>
                                <a onClick={() => {
                                    reachGoalYM('phone_click');
                                    reachGoalGA('phone_click');
                                }}
                                   href="tel:88003501595">
                                    <span className={`phone`}>8 800 350-15-95</span>
                                </a>
                                <a onClick={() => {
                                    reachGoalYM('phone_click');
                                    reachGoalGA('phone_click');
                                }}
                                   href="tel:+79109522022">
                                    <span className={`phone`}>8 910 952-20-22</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div id={`stickyHeader`} className={`headerBox__item`}>*/}
                <div style={{position: 'relative'}}>
                    <div className={`container`}>
                        <div className={`headerBox__item headerBox__item_sticky`}>
                            <Logo />
                            <div className={openClass} onClick={() => subMenuStore.openSubMenu()}>
                                {subMenuStore.open ?
                                    <Svg id={`dagger-close`} className={`svg__headerCatalogButtonClose`} />
                                    :
                                    <Svg id={`headerCatalogButton`} className={`svg__headerCatalogButton`} />
                                }
                                <p className={`text`}>Каталог</p>
                            </div>
                            <div className={`headerBox__searchingForm`}>
                                <SearchForm {...props} />
                            </div>
                            <div className={`headerBox__icons`}>
                                {!isDesktop() && (
                                    <LinkLoad href={`/search`} aria-label="Главная" className={`icon`}>
                                        <Svg id={`search`} className={`svg__searchHeader`} />
                                    </LinkLoad>
                                )}
                                {!isMobile() && (
                                    <>
                                        <div className={`icon icon__profile`}
                                             onClick={() => rightMenuStore.openRightMenu()}
                                        >
                                            <Svg id={`profile`} className={`svg__profile`} aria-label="Профиль" />
                                            {authCheck && active_orders !== 0 && (
                                                <span className={`icon__dots`}></span>
                                            )}
                                        </div>
                                        <LinkLoad className={`icon icon__favorites`} href={`/favorites`}>
                                            <Svg
                                                id={`heart-header`}
                                                className={`svg__heart`}
                                                aria-label="Избранное"
                                            />
                                            {favouritesStore.favouritesData.length !== 0 &&
                                                <span className={`icon__dots`}></span>}
                                        </LinkLoad>
                                        <LinkLoad className={`icon inertiaButton`}
                                                  href={`/basket`}
                                                  method={`post`}
                                                  as={'button'}
                                                  data={{
                                                      paymentMethod: basketStore.valuePaymentMethod,
                                                      // flagBonusesPromoCod: basketStore.flagBonusesPromoCod,
                                                      // promoCodeValue: basketStore.promo_id,
                                                      promoCodeValue: basketStore.promoCodeValues,
                                                      certificateData: basketStore.certificateData,
                                                      // deliveryData: basketStore.deliveryData,
                                                      bonuses: basketStore.subtractBonuses,
                                                  }}
                                        >
                                            <Svg id={`headerBasket`} className={`svg__basket`} />
                                            {basketStore.basketCount !== 0 &&
                                                <span className={`basket-count`}>{basketStore.basketCount}</span>}
                                        </LinkLoad>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <CatalogSubMenu {...props} />
                </div>
            </div>
        </header>
    )
};

const CatalogSubMenu = (props) => {
    const {stores = {}, imgVersion = '', catalogMenu = []} = props;
    const {subMenuStore = {}, filterStore = {}} = stores;

    const open = classNames('catalog-sub-menu', props.className, {
        'open': subMenuStore.open,
        'sticky': subMenuStore.stickySubMenu
    });

    const openOverlay = classNames('catalog-sub-menu-overlay', props.className, {
        'open': subMenuStore.open,
        'sticky': subMenuStore.stickySubMenu
    });

    let categories = [], sections = [];
    catalogMenu.map((el, i) => {
        categories.push(
            <LinkLoad key={el.id}
                      onClick={() => filterStore.handleClickLink()}
                      className={`catalog-sub-menu__list js-catalogMenuList${i === 0 ? ' active' : ''}`}
                      href={`${el.url}`}
                      dataSrc={el.img}
                      onMouseOver={(e) => subMenuStore.createImg(e, el.id)}
            >
                <Svg id={el.svg} className={`svg__catalogSubMenu`} />
                {el.name}
            </LinkLoad>
        );

        const widthPercent = el.sections.length > 4 ? (100 / el.sections.length).toFixed(2) + '%' : '25%';

        sections.push(
            <div key={el.id}
                 id={`catalog_sub_menu_${el.id}`}
                 className={`catalog-sub-menu__item catalog-sub-menu__item_content${i === 0 ? '' : ' hidden'}`}>
                {el.sections.map((items) => {
                    return <div key={items.id}
                                className={`catalog-sub-menu__item_content-list`}
                                style={{width: widthPercent}}
                    >
                        <div className={`catalog-sub-menu__title`}>
                            {items.title}
                        </div>
                        {items.items.map((el) => {
                            return <LinkLoad key={el.id}
                                             onClick={() => filterStore.handleClickLink()}
                                             href={`${el.url}`}
                                             className={`catalog-sub-menu__list`}>
                                {el.name}
                            </LinkLoad>
                        })}
                    </div>
                })}
            </div>
        );
    });

    // const ImageBlock = useCallback(() => {
    //     return <div id={`newImg`} className={`catalog-sub-menu__item catalog-sub-menu__item_img`}>
    //         {subMenuStore.newImg && (
    //             <picture>
    //                 <source type={`image/webp`}
    //                         srcSet={`${subMenuStore.newImg['src']}.webp?v=${imgVersion}`}
    //                 />
    //                 <img width={`350`}
    //                      height={`350`}
    //                      loading={`lazy`}
    //                      src={`${subMenuStore.newImg['src']}.jpg?v=${imgVersion}`}
    //                      alt={`Красивое фото`}
    //                      title={`Красивое фото`}
    //                 />
    //             </picture>
    //         )}
    //     </div>
    // }, [subMenuStore.newImg['src']]);

    const ImageBlock = () => {
        return <div id={`newImg`} className={`catalog-sub-menu__item catalog-sub-menu__item_img`}>
            {subMenuStore.newImg && (
                <picture>
                    <source type={`image/webp`}
                            srcSet={`${subMenuStore.newImg['src']}.webp?v=${imgVersion}`}
                    />
                    <img width={`350`}
                         height={`350`}
                         loading={`lazy`}
                         src={`${subMenuStore.newImg['src']}.jpg?v=${imgVersion}`}
                         alt={`Красивое фото`}
                         title={`Красивое фото`}
                    />
                </picture>
            )}
        </div>
    };

    const Menu = useCallback(() => {
        return <>
            <div className={`catalog-sub-menu__item`}>
                <div className={`catalog-sub-menu__title`}>
                    <p>Украшения</p>
                </div>
                {categories}
            </div>
            {sections}
        </>
    }, [catalogMenu]);

    return <>
        <div id={`subMenu`} className={open}>
            <div className={`container`}>
                <div id={`sub-menu`} className={`catalog-sub-menu__wrapper`}>
                    <Menu />
                    <ImageBlock />
                </div>
            </div>
        </div>
        <div id={`subMenuOverlay`} className={openOverlay}
             onClick={() => subMenuStore.handleClickAwaySubMenu()}></div>
    </>
};

export default withStore(BaseLayout);
